import { ClassValue } from 'clsx';
import { Menu } from '@shared/components/Menu';
import { View } from '@shared/components/View';
import { Entity } from '@shared/data/entity/Entity';
import { API } from '@shared/types/api';
import { CardExportSubmenu } from './CardExportSubmenu';
import { CardHistoryMenuItem } from './CardHistoryMenuItem';
import { DeleteSubmenu } from './DeleteSubmenu';
import { DuplicateMenuItem } from './DuplicateMenuItem';
import { EditMenuItem } from './EditMenuItem';
import { SelectMultipleMenuItem } from './SelectMultipleMenuItem';
import { ShareSubmenu } from './ShareSubmenu';

interface Props {
  entity: Entity;
  workflowTemplate: API.WorkflowTemplateFragment;
  align?: 'left' | 'right';
  className?: ClassValue;
}

export function CardActionMenu({ entity, workflowTemplate, align = 'right', className }: Props) {
  return (
    <View className={className}>
      <Menu align={align}>
        <Menu.IconButton testID="card-action-menu-button" />
        <Menu.Content testID="card-action-menu">
          <EditMenuItem entity={entity} workflowTemplate={workflowTemplate} />
          <DuplicateMenuItem entityId={entity.id} />
          <SelectMultipleMenuItem entity={entity} />
          <ShareSubmenu entityId={entity.id} />
          <CardExportSubmenu entityId={entity.id} />
          <CardHistoryMenuItem entityId={entity.id} />
          <Menu.Separator />
          <DeleteSubmenu entityId={entity.id} workflowTemplateId={workflowTemplate.id} />
        </Menu.Content>
      </Menu>
    </View>
  );
}
